import React from 'react';
import './index.css';

const NotificationBar = () => <div className="red-row"></div>;

export default React.memo(NotificationBar);
